<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import DontExist from "@/components/company/components/DontExist"
import evidenciaProfesiogramaAPI from "../../../services/standards/evidenciaProfesiograma/evidenciaProfesiogramaAPI";
import perfilesCargoAPI from "../../../services/standards/perfilesCargo/perfilesCargoAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Perfiles de cargo - profesiograma",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    DontExist,
  },
  data() {

    return {
      title: "3.1.3 Perfiles de cargo - profesiograma",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Perfiles de cargo - profesiograma",
        },
        {
          text: "Evidencia comunicación profesiograma",
          active: true,
        },
      ],

      colaboradorProveedor: [],
      types: [],
      lista: [],
      loading: true,
      loading2: true,
      acta: null,
      profesiograma: null,

      itemData: null,

      item: null,

      itemData: null,

      file: null,

      perfil: {

        date: null,
        supplier: null,
        observations: null,
        evidence: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },

  validations: {
    perfil: {

      date: {
        required,
      },
      supplier: {
        required,
      },

    },
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(25)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getType() {
      perfilesCargoAPI.getTypes()
        .then((response) => {
          this.loading = false
          let types = response.data;
          this.types = types
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    getShow() {
      evidenciaProfesiogramaAPI
        .show(this.$route.params.id)
        .then((response) => {
          this.loading = false
          this.perfil = {
            date: response.data.date,
            supplier: response.data.supplier,
            observations: response.data.observations,
            evidence: response.data.evidence,
            companies_id: response.data.companies_id,
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      evidenciaProfesiogramaAPI.getAll(this.companyID)
        .then((response) => {
          let identificacion = response.data.data;
          this.lista = identificacion
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getItemData();
    this.getList();
    this.getType();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>

              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-4 px-2" label="Fecha" label-for="trainingDate">
                    <b-form-input disabled type="date" id="trainingDate" v-model="perfil.date"
                      :class="{ 'is-invalid': $v.perfil.date.$error && submitted }">
                    </b-form-input>
                    <div v-if="submitted && $v.perfil.date.$error">
                      <small v-if="!$v.perfil.date.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>

                  </b-form-group>
                  <b-form-group class="col-md-4 px-2 mb-3" label="Proveedor evaluaciones médicas" label-for="file">
                    <h5>{{ perfil.supplier }}</h5>
                    <div v-if="submitted && $v.perfil.supplier.$error">
                      <small v-if="!$v.perfil.supplier.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Evidencia de la comunicación" label-for="file">

                    <button :disabled="!allowAccess()" style=" background-color: transparent !important; border: none;"
                      type="button" @click="gotoDigitalOcean(`${perfil.evidence
                        }`)"> <i class="mdi mdi-cloud-download"></i>
                    </button>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="trainingDate">
                    <h5>{{ perfil.observations }}</h5>
                  </b-form-group>
                </div>
              </form>
            </div>
          </div>

        </div>

        <div v-else-if="!loading && classificationID > 3">
          <DontExist />
        </div>

        <div v-else-if="!loading">
          <DontExist />
        </div>
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>